import Vue from 'vue';

const success = (context, response) => {
  context.bookingsCheckings = response.data.checking;
  context.bookingsCheckouts = response.data.checkout;
  context.teamMembers = response.data.members;

  for(let i = 0; i < context.teamMembers.length; i++) {
    context.teamMembers[i].draggingBooking = [];
  }

  context.statusCounts = {
    toBeAssigned: 0,
    assigned: 0,
    done: 0,
    cleaningFast: 0,
    cancelled: 0
  };
  context.calculateCounts();
};

const failed = (context, error) => {

};

export default (context, selectedDay) => {
 return Vue.$http.get('bookings/planing-get-by-selected-day/'+selectedDay).
       then(response => {
           if(response && response.status === 200) {
             success(context, response);
           }
        }).catch(error => {
          failed(context, error);
        })
}



// WEBPACK FOOTER //
// ./src/app/services/booking/planingGetBookingsSelectedDay.js